// stripe.js
import { loadStripe } from '@stripe/stripe-js';

// Replace with your real publishable key - 123
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
